import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-task",
  "use": "icon-task-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-task\"><defs><style type=\"text/css\"></style></defs><path d=\"M886.272 288.768L819.2 209.92l-57.344-63.488A126.976 126.976 0 0 0 665.6 102.4H281.088A127.488 127.488 0 0 0 153.6 229.888v594.944a127.488 127.488 0 0 0 127.488 127.488h512a127.488 127.488 0 0 0 127.488-127.488V373.248a125.952 125.952 0 0 0-34.304-84.48z m-210.944 265.216l-137.728 169.984a41.984 41.984 0 0 1-32.256 15.872 43.008 43.008 0 0 1-32.768-14.336l-74.752-84.992A42.496 42.496 0 0 1 460.8 584.192l41.472 47.104 107.008-130.56a42.496 42.496 0 1 1 66.048 51.2z m30.72-187.904a51.2 51.2 0 0 1-51.2-51.2v-153.6l192 204.8z\" p-id=\"5894\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/task.svg
// module id = ebys
// module chunks = 7